export default {"src":"/_next/static/media/facebook.65d08451.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};